import React, { useState, useEffect } from 'react';
import { Send, CheckCircle, XCircle, Store } from 'lucide-react';

// --- KODE GOOGLE APPS SCRIPT BARU (UNTUK REFERENSI) ---
/* function doGet(e) {
  return HtmlService.createHtmlOutput('Hanya mendukung POST request');
}

function doPost(e) {
  var ss = SpreadsheetApp.getActiveSpreadsheet(); // Dapatkan Spreadsheet
  var data = e.postData.contents;

  var params = {};
  data.split('&').forEach(function(param) {
    var parts = param.split('=');
    // Menggunakan decodeURIComponent untuk menangani spasi dan karakter khusus
    params[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]); 
  });
  
  // Ambil nama Toko untuk menentukan sheet tujuan
  var tokoName = params.Toko || '';

  // Cari sheet berdasarkan nama Toko
  var sheet = ss.getSheetByName(tokoName);

  // Jika sheet tidak ditemukan, log error atau default ke sheet pertama
  if (!sheet) {
    // PENTING: Anda harus memastikan tab/sheet dengan nama tersebut sudah ada!
    sheet = ss.getSheets()[0]; // Default ke sheet pertama jika nama toko tidak ditemukan
  }
  
  // Mengambil data dari formulir
  var timestamp = new Date();
  var tanggal = params.Tanggal || '';
  var jam = params.Jam || '';
  var tiket = params.Tiket ? Number(params.Tiket) : ''; // Simpan sebagai angka
  var wl = params.WL || '';

  // Menambahkan baris baru ke Sheet 
  // URUTAN KOLOM BARU DI GOOGLE SHEET: Timestamp, Toko, Tanggal, Jam, Tiket, WL
  sheet.appendRow([timestamp, tokoName, tanggal, jam, tiket, wl]);

  // Mengembalikan respons
  return ContentService.createTextOutput(JSON.stringify({result: 'success', message: 'Data saved successfully'}))
    .setMimeType(ContentService.MimeType.JSON);
}
*/
// --------------------------------------------------------------------


// Komponen utama aplikasi
const App = () => {
  const TOKO_OPTIONS = [
    'TOTO855', 'BOS5000', 'FANTASTIC4D', 'CANDUAN188', 'IRON4D', 
    'CCTVSLOT', 'LINK5000', 'PIKASLOT', 'ELLOSLOT', 'ETHER777'
  ];

  // Fungsi untuk mendapatkan waktu saat ini dalam format HH:MM (24 jam)
  const getCurrentTime = () => {
    const now = new Date();
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    return `${hours}:${minutes}`;
  };

  // State untuk data formulir
  const [formData, setFormData] = useState({
    toko: '',    // Toko harus diisi pertama
    tanggal: '',
    jam: getCurrentTime(), // Waktu diinisialisasi otomatis
    tiket: '', // Tiket menyimpan nilai bersih (e.g., "10000")
    wl: '',    // Whitelist/Waitlist status (e.g., "Yes" atau "100000")
  });

  // Mengisi Tanggal saat ini secara otomatis
  useEffect(() => {
    // Set tanggal hari ini (format YYYY-MM-DD)
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); 
    const dd = String(today.getDate()).padStart(2, '0');

    setFormData(prev => ({ 
        ...prev, 
        tanggal: `${yyyy}-${mm}-${dd}`,
    }));
  }, []); // Hanya dijalankan sekali saat mount

  // State untuk mengontrol UI (loading dan pesan status)
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null); // 'success', 'error', atau null

  // ** PENTING: GANTI DENGAN URL GOOGLE APPS SCRIPT ANDA **
  const GOOGLE_APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycbzgdkmxeznAdHoB4BceUno9Wr4Zy8LZAtY5OkdnIJmqO0J5H6tckeO1ZYWXPL6STjFW/exec'; // URL Apps Script Anda

  // Function untuk membersihkan string dari pemisah ribuan (e.g., "10.000" -> "10000")
  const cleanNumber = (formattedValue) => {
    if (!formattedValue) return '';
    // Menghapus semua titik (.) dan koma (,) dari string
    return formattedValue.toString().replace(/\./g, '').replace(/,/g, '');
  };

  // Function untuk memformat angka dengan pemisah ribuan (e.g., "10000" -> "10.000")
  const formatNumber = (value) => {
    if (value === null || value === '') return ''; 
    // Pastikan hanya digit yang diambil
    const cleaned = ('' + value).replace(/[^0-9]/g, '');
    if (!cleaned) return '';
    
    // Menggunakan Intl.NumberFormat untuk format Indonesia (id-ID)
    return new Intl.NumberFormat('id-ID').format(Number(cleaned));
  };


  // Handler perubahan input
  const handleChange = (e) => {
    const { id, value } = e.target;
    
    if (id === 'tiket') {
      // Input Tiket: Harus berupa angka bersih di state
      const cleanedValue = cleanNumber(value);
      
      // Hanya izinkan angka non-negatif
      if (cleanedValue === '' || /^\d+$/.test(cleanedValue)) {
          setFormData(prev => ({
            ...prev,
            // Simpan angka bersih di state (tanpa separator)
            [id]: cleanedValue,
          }));
      }
      
    } else if (id === 'wl') {
      // Input WL: Jika berupa angka, simpan angka bersih. Jika string non-numerik, simpan mentah.
      const rawValueWithoutSeparator = cleanNumber(value);

      if (rawValueWithoutSeparator === '' || /^\d+$/.test(rawValueWithoutSeparator)) {
        // Jika input adalah string angka, simpan nilai bersih
         setFormData(prev => ({ ...prev, [id]: rawValueWithoutSeparator }));
      } else {
        // Jika input bukan angka (e.g., "Yes", "100K"), simpan nilai mentah
         setFormData(prev => ({ ...prev, [id]: value }));
      }
      
    } else {
      setFormData(prev => ({
        ...prev,
        [id]: value,
      }));
    }
  };

  // Handler submit formulir
  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus(null);
    setIsLoading(true);

    if (!formData.toko) {
        setStatus('error');
        setIsLoading(false);
        return; // Jangan kirim jika Toko kosong
    }

    try {
      // Data yang dikirim ke Apps Script adalah nilai bersih dari state (tanpa separator)
      const dataToSend = new URLSearchParams({
        Toko: formData.toko,       // NAMA TOKO BARU
        Tanggal: formData.tanggal,
        Jam: formData.jam, // Dikirim sebagai string 24 jam
        Tiket: formData.tiket, 
        WL: formData.wl,       
      }).toString();

      // Mengirim permintaan POST ke Google Apps Script
      await fetch(GOOGLE_APPS_SCRIPT_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: dataToSend,
        mode: 'no-cors' 
      });

      setStatus('success');
      // Reset formulir, pertahankan Toko tetap terpilih, Jam dan Tanggal diisi otomatis
      setFormData(prev => ({ 
          toko: prev.toko, 
          tanggal: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-${String(new Date().getDate()).padStart(2, '0')}`,
          jam: getCurrentTime(), 
          tiket: '', 
          wl: '' 
      })); 

    } catch (error) {
      console.error("Gagal mengirim data:", error);
      setStatus('error');
    } finally {
      setIsLoading(false);
      setTimeout(() => setStatus(null), 5000);
    }
  };

  // Komponen untuk menampilkan pesan status
  const StatusMessage = ({ type, message }) => {
    if (!message) return null;

    const baseClasses = "flex items-center p-3 mb-4 rounded-lg shadow-md transition-opacity duration-300";
    const successClasses = "bg-green-100 text-green-800 border-green-300";
    const errorClasses = "bg-red-100 text-red-800 border-red-300";

    return (
      <div className={`${baseClasses} ${type === 'success' ? successClasses : errorClasses}`}>
        {type === 'success' ? <CheckCircle className="w-5 h-5 mr-2" /> : <XCircle className="w-5 h-5 mr-2" />}
        <span>{message}</span>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4 font-sans">
      <div className="w-full max-w-lg bg-white p-8 rounded-xl shadow-2xl">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-6 text-center">
          Tiket 2 Jam
        </h1>
        <p className="text-gray-500 mb-6 text-center">
          Pilih Toko, lalu masukkan detail Tanggal, Jam, Tiket, dan WL.
        </p>

        <StatusMessage
          type={status}
          message={
            status === 'success'
              ? 'Data berhasil dikirim ke Google Sheets!'
              : status === 'error'
              ? formData.toko ? 'Gagal mengirim data. Cek koneksi atau URL Apps Script Anda.' : 'Pilih Toko terlebih dahulu.'
              : null
          }
        />

        <form onSubmit={handleSubmit} className="space-y-4">
          
          {/* --- INPUT TOKO (DROPDOWN) --- */}
          <div>
            <label htmlFor="toko" className="flex items-center text-sm font-medium text-gray-700 mb-1">
                <Store className="w-4 h-4 mr-2 text-blue-600"/> Toko Tujuan
            </label>
            <select
                id="toko"
                value={formData.toko}
                onChange={handleChange}
                required
                className="w-full px-4 py-3 border border-gray-300 rounded-lg bg-white shadow-sm focus:ring-blue-500 focus:border-blue-500 transition duration-150 appearance-none"
            >
                <option value="" disabled>--- Pilih Toko ---</option>
                {TOKO_OPTIONS.map(toko => (
                    <option key={toko} value={toko}>{toko}</option>
                ))}
            </select>
            {formData.toko && (
                 <p className="mt-1 text-xs text-blue-600">
                    Data akan masuk ke tab/sheet bernama: **{formData.toko}**
                </p>
            )}
          </div>
          {/* ----------------------------- */}

          <div className="grid grid-cols-2 gap-4">
            <div>
              <label htmlFor="tanggal" className="block text-sm font-medium text-gray-700 mb-1">
                Tanggal (Otomatis Hari Ini)
              </label>
              <input
                type="date"
                id="tanggal"
                value={formData.tanggal}
                onChange={handleChange}
                required
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition duration-150"
              />
            </div>

            <div>
              <label htmlFor="jam" className="block text-sm font-medium text-gray-700 mb-1">
                Jam (Otomatis Saat Ini)
              </label>
              <input
                type="text"
                id="jam"
                value={formData.jam}
                onChange={handleChange}
                // Dihapus required karena sudah terisi otomatis
                className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition duration-150"
                placeholder="HH:MM"
              />
            </div>
          </div>
          
          <div>
            <label htmlFor="tiket" className="block text-sm font-medium text-gray-700 mb-1">
              Jumlah Tiket
            </label>
            <input
              type="text" 
              id="tiket"
              value={formatNumber(formData.tiket)}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition duration-150"
              placeholder="Masukkan jumlah tiket (e.g., 10.000)"
            />
          </div>

          <div>
            <label htmlFor="wl" className="block text-sm font-medium text-gray-700 mb-1">
              Status WL (Waitlist/Whitelist)
            </label>
            <input
              type="text"
              id="wl"
              value={/^\d+$/.test(formData.wl) ? formatNumber(formData.wl) : formData.wl}
              onChange={handleChange}
              required
              className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-blue-500 focus:border-blue-500 transition duration-150"
              placeholder="Contoh: Yes / No / 100.000"
            />
          </div>
          
          <button
            type="submit"
            disabled={isLoading || !formData.toko}
            className={`w-full flex items-center justify-center py-3 px-4 border border-transparent text-base font-medium rounded-lg text-white shadow-lg transition duration-300 transform ${
              (isLoading || !formData.toko)
                ? 'bg-blue-400 cursor-not-allowed'
                : 'bg-blue-600 hover:bg-blue-700 hover:shadow-xl active:scale-98'
            }`}
          >
            {isLoading ? (
              <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
              </svg>
            ) : (
              <>
                <Send className="w-5 h-5 mr-2" />
                Kirim Data ke {formData.toko || 'Toko'}
              </>
            )}
          </button>
        </form>

      </div>
    </div>
  );
};

export default App;
